import axiosInstance from "@/api/axios";

export interface CompanyDetailsObject {
  _id: string;
  companyName: string;
  email: string;
  phoneNumber: string;
  category: string[];
  address: string;
  country: string;
  county: string;
  province: string;
  region: string;
  city: string;
  citiesServed: string[];
  postalCode: string;
  companyDescription: string;
  website: string;
  facebookUrl: string;
  instagramUrl: string;
  youTubeUrl: string;
  linkedInUrl: string;
  xUrl: string;
  profileImage: File | null;
  profileUrl: string;
  contactName: string;
  profileImageUrl: string;
  seo: string;
}

export interface ProjectDetail {
  _id: string;
  projectName: string;
  serviceType: string[];
  projectType: string[];
  projectAddress: string;
  city: string;
  latitude: number;
  longitude: number;
  builderName: string;
  buildPhone: string;
  builderEmail: string;
  projectImages: string[];
  country: string;
  province: string;
  region: string;
  county: string;
  projectYear: number;
  type: string;
  builderWebsite: string;
}

export interface ProjectFilters {
  title: string;
  type: string;
  keyType: string;
  filterKey: string;
  options: {
    label: string;
    value: string | number;
  }[];
  allowMultipleSelections: boolean;
}

export const fetchCompanyDetails = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: `/odoo/api/v1/companyProfile`,
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addBuilderProject = async (data: any) => {
  try {
    console.log(data, "line 22");
    const response = await axiosInstance({
      method: "POST",
      url: `/formdata/odoo/api/v1/companyProfile/projects`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data,
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateBuilderProject = async (data: any) => {
  try {
    console.log(data, "line 22");
    const response = await axiosInstance({
      method: "POST",
      url: `/formdata/odoo/api/v1/companyProfile/projects/update`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data,
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const getWorkCategory = async () => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "GET",
      url: `/odoo/api/v1/companyProfile/getWorkCategory`,
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
      // data,
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const getServiceOffered = async () => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "GET",
      url: `/odoo/api/v1/companyProfile/projects/serviceTypes`,
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
      // data,
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const getValidProfileUrl = async (profileUrl: string, companyId: number) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/companyProfile/isValidProfileUrl",
      params: {
        profileUrl: profileUrl,
        companyId: companyId
      },
    });

    return response.data; //  Return response data if needed
  } catch (error) {
    console.error("Error validating profile URL:", error);
    throw error; // Optional: rethrow if you want to handle it higher up
  }
};
export const getValidProfileUrlForadd = async (profileUrl: string) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/companyProfile/isValidProfileUrl",
      params: {
        profileUrl: profileUrl,
        // companyId: companyId
      },
    });

    return response.data; //  Return response data if needed
  } catch (error) {
    console.error("Error validating profile URL:", error);
    throw error; // Optional: rethrow if you want to handle it higher up
  }
};

export const getMasterData = async (param: object) => {
  // setIsLoading(true);
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/crm/masterData",
      params: param,
    });
    console.log("response", response);
    // setColumns(response.data.data.data.stages);
    return response.data.data;
  } catch (err) {
    console.log("err", err);
  } finally {
    // setIsLoading(false);
  }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addCompanyDetails = async (data: any) => {
  try {
    console.log(data, "line 22");
    const response = await axiosInstance({
      method: "POST",
      url: `/formdata/odoo/api/v1/companyProfile`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data,
    });

    console.log("Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

export const getCompanyProfileProjects = async (data: object) => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/companyProfile/projects/fetch",
      data,
    });

    console.log("getCompanyProfileProjects API Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching stage details:", err);
    throw err;
  }
};

// export const getServiceTypes = async () => {
//   try {
//     // console.log(data,"line 22")
//     const response = await axiosInstance({
//       method: "GET",
//       url: "/odoo/api/v1/companyProfile/projects/serviceTypes",
//     });

//     console.log("getServiceTypes API Response:", response);
//     return response.data;
//   } catch (err) {
//     console.error("Error fetching service types:", err);
//     throw err;
//   }
// };

export const getCompanyProfileProjectFilters = async (params: object) => {
  try {
    // console.log(data,"line 22")
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/companyProfile/projects/filters",
      params,
    });

    console.log("getCompanyProfileProjectFilters API Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching service types:", err);
    throw err;
  }
};
